import { InvoiceLiveStatusProvider } from '../invoices/InvoiceLiveStatusContext';

export default function RealTimeProviders({ children }) {
  return <InvoiceLiveStatusProvider>{children}</InvoiceLiveStatusProvider>;
}
